export const setFairProducts = (products) => ({
    type: 'FAIR_PRODUCTS_SET',
    products
});